export default "__VITE_ASSET__D9_$7ypp__"